import { EnhancementsService } from './../../services/enhancements.service';
import {
	ChangeDetectionStrategy,
	Component,
	inject,
	OnInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuComponent } from '../../components/menu/menu.component';
import { ApiService, DatastoreService } from '../../services';
import { map, Observable, switchMap } from 'rxjs';
import { EnhancementItemComponent } from './enhancement-item.component';
import { Enhancement } from './enhancement-item.component';
import { ActivatedRoute } from '@angular/router';

@Component({
	selector: 'app-enhancements',
	standalone: true,
	imports: [CommonModule, MenuComponent, EnhancementItemComponent],
	templateUrl: './enhancements.component.html',
	styleUrl: './enhancements.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnhancementsComponent implements OnInit {
	apiService = inject(ApiService);
	dataStore = inject(DatastoreService);
	route = inject(ActivatedRoute);
	enhancementsService = inject(EnhancementsService);

	// Add these properties or replace with actual types/initialization as needed
	booking: Record<string, any>;
	service: Record<string, any>;

	extraItems$: Observable<Record<string, any>[]>;

	ngOnInit(): void {
		this.service = this.dataStore.selectedService;
		if (!this.service) {
			const serviceStr = localStorage.getItem('service') as string;
			this.service = JSON.parse(serviceStr);
		}

		this.booking = this.dataStore.booking;
		if (!this.booking) {
			const bookingStr = localStorage.getItem('ceremony') as string;
			this.booking = JSON.parse(bookingStr);
		}

		this.extraItems$ = this.route.queryParams.pipe(
			switchMap((params) => {
				let category = undefined;
				if (params.category) {
					category = params.category;
				}
				return this.enhancementsService
					.getEnhancements(
						this.booking.company_id,
						this.service.global_id,
						category
					)
					.pipe(map((extras) => extras.map(this.mapToEnhancementItem)));
			})
		);
	}

	mapToEnhancementItem(item: Record<string, any>): Enhancement {
		return {
			description: item.description || '',
			maxStockCount: item.itemMaxStockCount || 0,
			name: item.name || '',
			price: item.price || 0,
			image: item.data.image || '',
		};
	}
}
